import { render, staticRenderFns } from "./FiltrosOpenText.vue?vue&type=template&id=60427691&"
import script from "./FiltrosOpenText.vue?vue&type=script&lang=js&"
export * from "./FiltrosOpenText.vue?vue&type=script&lang=js&"
import style0 from "./FiltrosOpenText.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60427691')) {
      api.createRecord('60427691', component.options)
    } else {
      api.reload('60427691', component.options)
    }
    module.hot.accept("./FiltrosOpenText.vue?vue&type=template&id=60427691&", function () {
      api.rerender('60427691', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/_vue/componentes/FiltrosOpenText.vue"
export default component.exports